import Vue from 'vue';
import Router from 'vue-router';
import Intro from '@/views/intro/Intro';
import Landing from '@/views/landing/Landing';
import AccLogin from '@/views/acc/acc-login';
import AccJobGroup from '@/views/acc/acc-job-group';
import ReportMy from '@/views/report/report-my';
import ReportRole from '@/views/report/report-role';
import TestQuestion from '@/views/test/test-question';
import AccDetail from '@/views/acc/acc-detail';
import Mc6Intro from '@/views/mc6/mc6-intro';
import MatchList from '@/views/match/match-list';
import MatchQr from '@/views/match/match-qr';
import MatchQrScan from '@/views/match/match-qr-scan';
import MatchResult from '@/views/match/match-result';
import MatchMakeGroup from '@/views/match/match-make-group';
import MatchInvite from '@/views/match/match-invite';
import MatchGroup from '@/views/match/match-group';
import TermsPrivacy from '@/views/terms/terms-privacy';
import TermsService from '@/views/terms/terms-service';
import TermsAgree from '@/views/terms/terms-agree';
import Profile from '@/views/profile';
import AccDelete from '@/views/acc/acc-delete';
import AccDeleteDone from '@/views/acc/acc-delete-done';
import AccSignUp from '@/views/acc/acc-signup';
import AccDone from '@/views/acc/acc-done';
import TestIntro from '@/views/test/test-intro';
import TestDone from '@/views/test/test-done';
import AccFindPw from '@/views/acc/acc-find-pw';
import AccSignUpSns from '@/views/acc/acc-signup-sns';
import NoticeIntro from '@/views/notice/notice-intro';
import NoticeList from '@/views/notice/notice-list';
import NoticeDetail from '@/views/notice/notice-detail';
import Notification from '@/views/mc6/notification';
import NotFound from '@/views/not-found';

import store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'intro',
      component: Intro,
    },
    {
      path: '/landing',
      name: 'landing',
      component: Landing,
    },
    {
      path: '/acc/login',
      name: 'acc-login',
      component: AccLogin,
    },
    {
      path: '/acc/signup',
      name: 'acc-signup',
      component: AccSignUp,
    },
    {
      path: '/acc/job-group',
      name: 'acc-job-group',
      component: AccJobGroup,
    },
    {
      path: '/report',
      name: 'report-my',
      component: ReportMy,
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/role',
      name: 'report-role',
      component: ReportRole,
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/test/question',
      name: 'test-question',
      component: TestQuestion,
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/profile/edit',
      name: 'acc-detail',
      component: AccDetail,
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/mc6',
      name: 'mc6-intro',
      component: Mc6Intro,
      children: [
        {
          path: ':id',
          component: Mc6Intro,
        },
      ],
    },
    {
      path: '/match/list',
      name: 'match-list',
      component: MatchList,
      children: [
        {
          path: ':id',
          component: MatchList,
        },
      ],
    },
    {
      path: '/match/qr',
      name: 'match-qr',
      component: MatchQr,
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/match/qr-scan',
      name: 'match-qr-scan',
      component: MatchQrScan,
    },
    {
      path: '/match/result/:id',
      name: 'match-result',
      component: MatchResult,
      children: [
        {
          path: ':profile',
          component: Profile,
          meta: {
            authRequired: true,
          },
        },
      ],
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/match/make/group',
      name: 'match-make-group',
      component: MatchMakeGroup,
    },
    {
      path: '/match/invite',
      name: 'match-invite',
      component: MatchInvite,
    },
    {
      path: '/match/group',
      name: 'match-group',
      component: MatchGroup,
    },
    {
      path: '/terms/privacy',
      name: 'terms-privacy',
      component: TermsPrivacy,
    },
    {
      path: '/terms/service',
      name: 'terms-service',
      component: TermsService,
    },
    {
      path: '/terms/agree',
      name: 'terms-agree',
      component: TermsAgree,
    },
    {
      path: '/acc/delete',
      name: 'acc-delete',
      component: AccDelete,
    },
    {
      path: '/acc/delete/done',
      name: 'acc-delete-done',
      component: AccDeleteDone,
    },
    {
      path: '/acc/done',
      name: 'acc-done',
      component: AccDone,
    },
    {
      path: '/test/intro',
      name: 'test-intro',
      component: TestIntro,
    },
    {
      path: '/test/done',
      name: 'test-done',
      component: TestDone,
    },
    {
      path: '/acc/find/pw',
      name: 'acc-find-pw',
      component: AccFindPw,
    },
    {
      path: '/acc/signup/sns/:snsType',
      name: 'acc-signup-sns',
      component: AccSignUpSns,
    },
    {
      path: '/notice',
      name: 'notice-intro',
      component: NoticeIntro,
      children: [
        {
          path: 'list/:type',
          component: NoticeList,
        },
        {
          path: ':item',
          component: NoticeDetail,
        },
      ],
    },
    {
      path: '/notification',
      name: 'notification',
      component: Notification,
    },

    // Not found
    {
      path: '*',
      name: 'not-found',
      component: NotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // to: 이동할 url에 해당하는 라우팅 객체
  if (to.matched.some(routeInfo => routeInfo.meta.authRequired)) {
    if (!store.getters.getAccessToken) {
      next('/acc/login');
    } else {
      next();
    }
  } else {
    if (store.getters.getAccessToken) {
      if (to.matched.some(routeInfo => routeInfo.path === '/acc/login')
        || to.matched.some(routeInfo => routeInfo.path === '/acc/signup')
        || to.matched.some(routeInfo => routeInfo.path === '')) {
        next('mc6');
        return;
      }
    } else if (store.getters.getTmpClientId && to.matched.some(routeInfo => routeInfo.path === '/acc/signup')) {
      const clientId = store.getters.getTmpClientId;
      store.dispatch('clearTmpClientId').then();
      next(`/acc/signup?clientId=${clientId}`);
      return;
    }
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js